import type { SVGProps } from 'react';
const DawnFlagSC = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-SC_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-SC_svg__a)">
      <path fill="url(#dawn-flag-SC_svg__b)" d="M22 0H0v16h22v-5.333L0 16 22 5.333z" />
      <path fill="#0858B4" d="M0 0h7.333L0 16z" />
      <path fill="#ED3535" d="M14.667 0H22v5.333L0 16z" />
      <path fill="#08964F" d="M22 16v-5.333L0 16z" />
      <path fill="#FFDD67" d="M7.333 0h7.334L0 16z" />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-SC_svg__b"
        x1={0}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1DBE4F" />
        <stop offset={1} stopColor="#159B3F" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagSC;
